import { PrismicNextImage } from '@prismicio/next';
import { PrismicLink, PrismicRichText } from '@prismicio/react';
import { ImageField, RichTextField } from '@prismicio/types';
import type * as prismic from '@prismicio/client';
import Link from 'next/link';

interface CaseStudyCardProps {
  link: prismic.LinkField<string, string, unknown, prismic.FieldState, never>;
  industry: string;
  description: RichTextField;
  service: string;
  backgroundImage: ImageField<never>;
}

const CaseStudyCard = ({
  link,
  industry,
  description,
  service,
  backgroundImage,
}: CaseStudyCardProps) => {
  return (
    <PrismicLink
      field={link}
      internalComponent={Link}
      className="rounded-[24px] overflow-hidden w-full font-inter cursor-pointer flex flex-col"
    >
      <div
        style={{
          background:
            'linear-gradient(to right, rgba(255,255,255,0.15), rgba(3,191,158,0.15), rgba(255,255,255,0.15))',
        }}
        className="p-6 flex flex-col gap-4 flex-grow"
      >
        <h3 className="text-green-1 font-[500] text-xs leading-[18px] uppercase">
          {industry}
        </h3>
        <div className="inline text-white font-normal text-xl leading-7 underline h-[114px] text-ellipsis overflow-hidden">
          <PrismicRichText field={description} />
        </div>
        <h4 className="text-green-1 font-[500] text-xs leading-[18px] uppercase">
          {service}
        </h4>
      </div>

      <PrismicNextImage
        field={backgroundImage}
        className="w-full h-[140px] object-cover"
        alt=""
      />
    </PrismicLink>
  );
};

export default CaseStudyCard;
